
import SizeRecommendationBadge from './SizeRecommendationBadge';
import SizeRecommendationSizeOptionStats from './SizeRecommendationSizeOptionStats';
import SizeRecommendationSizeFeedbackFilters from './SizeRecommendationSizeFeedbackFilters';
import SizeRecommendationSizeFeedbacks from './SizeRecommendationSizeFeedbacks';

export default {
  i18nComponentKey: 'WidgetAddOnSizeRecommendationPopup.components.SizeRecommendationResultView',
  name: 'SizeRecommendationResultView',
  components: {
    SizeRecommendationBadge,
    SizeRecommendationSizeOptionStats,
    SizeRecommendationSizeFeedbackFilters,
    SizeRecommendationSizeFeedbacks
  },
  props: {
    recommendedSizes: { type: Array, default: null },
    sizeOptionStats: { type: Array, default: () => [] },
    sizeFeedbacks: { type: Array, default: () => [] },
    sizeFeedbacksPagy: { type: Object, default: null },
    sizeFeedbackFilters: { type: Object, default: null },
    selectedSizeFeedbackFilters: { type: Object, default: () => ({}) },
    height: { type: Number, required: true },
    weight: { type: Number, required: true },
    preferredFitType: { type: String, default: null }
  },
  computed: {
    mainRecommendedSize() {
      return this.recommendedSizes && this.recommendedSizes[0];
    },
    secondaryRecommendedSize() {
      return this.recommendedSizes && this.recommendedSizes[1];
    },
    preferredFitName() {
      return this.$t(`fit_names.${this.preferredFitType}`);
    },
    title() {
      if (!this.mainRecommendedSize) return this.$t('title_empty');
      if (!this.secondaryRecommendedSize) {
        return this.$t('title_single', { size: this.mainRecommendedSize });
      }
      return this.$t('title_fit', {
        fit: this.preferredFitName,
        size: this.mainRecommendedSize
      });
    },
    subtitle() {
      if (!this.mainRecommendedSize) return this.$t('subtitle_empty');
      if (!this.secondaryRecommendedSize) return this.$t('subtitle_single');
      return this.$t('subtitle_secondary', {
        size: this.secondaryRecommendedSize
      });
    }
  }
};
